module.exports = __webpack_public_path__ + "img/Commuter.1512863.svg";